import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioVolunteer, InstitutionInfo } from '../model/clergy-bio-app-models';
import { YesNoIndicators } from '../../../global/models/api-model';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { FormGroup } from '../../../global/components/layout/form-group';
import { getClergyBioInstitutions } from '../../../global/ducks/clergy-bio-api';
import { autocompleteStyles } from '../../../global/constants/theme/styles/components/autocomplete';
import { formInputErrorStyles } from '../../../Global/constants/theme/styles/components/form-input-error-styles';


interface Props {
	settings: ClergyBioSettings;
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	volunteerItem: ClergyBioVolunteer;
	defaultValue: ClergyBioVolunteer;
	setList?: any;
	miscellaneous?: boolean;
}

function ClergyBioVolunteerItem(props: Props) {
	const autocompleteClasses = autocompleteStyles();
	const buttonClasses = buttonStyles();
	const { settings, arrayField, id, formikProps, setList, volunteerItem, miscellaneous, defaultValue } = props;
	const formInputErrorStylesClasses = formInputErrorStyles();

	const remove = () => {
		if (defaultValue?.id) {
			const list = _.cloneDeep(formikProps?.values[arrayField]);
			const toDelete = { ...defaultValue };
			toDelete.deleted = YesNoIndicators.Yes;
			list[id] = toDelete;
			const copy = _.cloneDeep(formikProps?.values);
			copy[arrayField] = list;
			setList(copy);
		} else {
			const list = _.cloneDeep(formikProps?.values[arrayField]);
			list.splice(Number(id), 1);
			const copy = _.cloneDeep(formikProps?.values);
			copy[arrayField] = list;
			setList(copy);
		}
	};

	const dispatch = useDispatch();
	const [options, setOptions] = useState([]);


	const debounceSearch = _.debounce((e) => {
		dispatch(getClergyBioInstitutions(
			e.target.value,
			(data) => setOptions(data?.results),
		));
	}, 500);

	const onChange = (event) => {
		formikProps.setFieldValue(`${arrayField}.${id}.institutionParsed`, event?.target?.value);
		debounceSearch(event);
	};


	const onSelect = (value) => {
		formikProps.setFieldValue(`${arrayField}.${id}.institutionParsed`, `${value?.name} ${value?.location}`);
		formikProps.setFieldValue(`${arrayField}.${id}.institutionInfo`, value);
		setOptions([]);
	};

	if (volunteerItem?.deleted === YesNoIndicators.Yes) {
		return null;
	}

	const institutionInfo = volunteerItem?.institutionInfo as InstitutionInfo;


	return (
		<ContentSpacer>
			<FormGroup>
				{
					!miscellaneous && institutionInfo?.name &&
					<ContentSpacer>
						<h4>{`${institutionInfo?.name} ${institutionInfo?.location}`}</h4>
					</ContentSpacer>
				}

				{
					miscellaneous &&
					<FormField
						name={`${arrayField}.${id}.institutionInfo`}
						label={settings?.miscellaneousInstitutionLabel}
						component='input'
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
					/>
				}
				{
					!miscellaneous && !institutionInfo?.name &&
					<div className={`form-item ${autocompleteClasses.autocompleteWrapper}`}>
						<FormField
							name={`${arrayField}.${id}.institutionParsed`}
							label={settings?.miscellaneousInstitutionLabel}
							component='input'
							touched={formikProps.touched}
							errors={formikProps.errors}
							onChange={(e) => onChange(e)}
							required
						/>
						{
							volunteerItem?.errors?.institutionInfo &&
							<div>
								<div className={formInputErrorStylesClasses.errorArrow}></div>
								<div className={formInputErrorStylesClasses.errorMessage}>
											{volunteerItem?.errors?.institutionInfo[0]}
								</div>
							</div>
						}
						<div className='autocomplete-container'>
							<ul className='autocomplete-list'>
								{
									options?.map(a => {
										return <li className='autocomplete-list-item'><button className='un-button autocomplete-list-item-button' type='button' onClick={() => onSelect(a)} >{a?.name} {a?.location}</button></li>;
									})
								}
							</ul>
						</div>
					</div>
				}

				<FormField
					name={`${arrayField}.${id}.position`}
					label={settings?.positionLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
				/>
				<FormField
					name={`${arrayField}.${id}.dateBegan`}
					label={settings?.positionStartDateLabel}
					component='datePicker'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
					autoWidth
				/>
				<FormField
					name={`${arrayField}.${id}.dateEnded`}
					label={settings?.positionEndDateLabel}
					component='datePicker'
					touched={formikProps.touched}
					errors={formikProps.errors}
					autoWidth
				/>
				<div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>

			</FormGroup>
		</ContentSpacer >
	);
}

ClergyBioVolunteerItem.defaultProps = {
	setList: null,
	miscellaneous: false,
};
export default ClergyBioVolunteerItem;